/* eslint-disable import/prefer-default-export */

export const assessment = state => state.assessment
